import { computed } from 'vue';
import { useJobDataStore } from "../stores/job-store";
import { useProfile } from "../stores/profile-store";

export function useGDPRText() {
    const jobData = useJobDataStore();
    const profile = useProfile();

    const isKarriereAtApplication = computed(() => jobData.companyName === 'karriere.at');
    const privacyPolicyText = computed(() => {
        const introduction = 'Wir behandeln deine Daten streng vertraulich.';
        const companyDisplayName = jobData.isChiffre ? 'das Unternehmen' : `<strong>${jobData.companyName}</strong>`;
        const usageType = isKarriereAtApplication.value ?
            'karriere.at erhält deine Bewerbung direkt' :
            `karriere.at übermittelt deine Bewerbung direkt an ${companyDisplayName}`;
        const additionalInfo = profile.hasUser ? ' und speichert sie in deinem persönlichen Profil' : '';
        return `${introduction} ${usageType}${additionalInfo}.`;
    });
    return {
        privacyPolicyText,
    };
}
